import React, { Ref, useEffect, useState } from 'react'
import styled from 'styled-components'
import { IAttachment, IChatDB, IUser } from './types'
import { FiUser } from '@react-icons/all-files/fi/FiUser'
import { MdAttachFile } from '@react-icons/all-files/md/MdAttachFile'
import { AiOutlineSend } from '@react-icons/all-files/ai/AiOutlineSend'
import { FaUsers } from '@react-icons/all-files/fa/FaUsers'
import { RiAddLine } from '@react-icons/all-files/ri/RiAddLine'
import { AiOutlineFile } from '@react-icons/all-files/ai/AiOutlineFile'
import { AiOutlineCloseCircle } from '@react-icons/all-files/ai/AiOutlineCloseCircle'
import { MentionsInput, Mention } from "react-mentions";
import Conversations from './Conversations/Conversations'
import ChatAvatar from './ChatAvatar'
import { formatBytes } from './chatHelper'
import LoopApi from '../../../../../helpers/LoopApi'
import axios from 'axios'


const { GlobalState } = require('reflux')

interface Props {
    updateSelf: (obj: any) => void,
    sendNotification: (obj: any) => void,
}

function ChatV2(props: Props) {
    const meetingURL = GlobalState.main.meetingName
    const myId = GlobalState.auth.jwt.data._id
    const users = GlobalState.main.users
    const myInfo = GlobalState.main.users.find((user: IUser) => user.id === myId)
    const roomName = GlobalState.main.db_meeting.name_alias

    const [chatDB, setChatDB] = useState<IChatDB>()
    const [message, setMessage] = useState('')
    const [receiver, setReceiver] = useState(meetingURL)
    const [attachments, setAttachments]: any = useState([])
    const [uploading, setUploading] = useState<any>({})


    const fileInput: any = React.createRef();

    //@ts-ignore
    var doc = window.shareDbConnection.get('chats', meetingURL)


    useEffect(() => {
        // props.updateSelf({ unreadMessages: 64 })

        doc.subscribe((error: any) => {
            if (error) return console.error(error)

            if (!doc.type) {
                doc.create({
                    roomId: meetingURL,
                    users: [myId],
                    seen: { [myId]: new Date().getTime() },
                    notification: { [myId]: 'all' },
                }, (error: any) => {
                    if (error) return console.error(error)
                    console.log('updated create', doc.data);
                    setChatDB(doc.data)
                })
            } else {
                const chatData = doc.data
                //Check if im already on users list
                if (chatData.users.indexOf(myId) === -1) {
                    //if not add my id
                    doc.submitOp([
                        { p: ['users', 0], li: myId },
                        { p: ['seen', myId], oi: new Date().getTime() },
                        { p: ['notification', myId], oi: 'all' },
                    ], {}, () => setChatDB(chatData))
                } else {
                    doc.submitOp([
                        { p: ['seen', myId], oi: new Date().getTime() },
                        { p: ['notification', myId], oi: 'all' },
                    ], {}, () => setChatDB(chatData))
                }

                // console.log('dox', { doc }, { users }, { myId }, { GlobalState }, { myInfo });
            }
        })

        doc.on('op', () => {
            console.log('updated op', doc.data);
            setChatDB(doc.data)
        })


    }, [])

    const ObjectId = (m = Math, d = Date, h = 16, s = (s: number) => m.floor(s).toString(h)) =>
        s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h))

    const sendText = (text: string) => {

        if (text !== '') {
            //@ts-ignore
            var doc = window.shareDbConnection.get('chat-contents', ObjectId())
            const timeStamp = new Date().getTime()

            doc.create({
                receiver,
                meetingURL,
                sender: {
                    avatar: myInfo.avatar_url || '',
                    name: myInfo.name,
                    id: myId
                },
                type: 'message',
                message: text,
                timeStamp,
                attachments: [],
                photos: [],
                reactions: []
            }, (err: any) => { if (!err) setMessage('') })
        }

        if (!!attachments.length)
            uploadAttachments()
    }

    //Insert 'All' in chat mention
    var modifiedUsers = [{ id: 'All', display: 'All' }]

    users.map((u: any) => {
        const name = u.first_name + u.last_name
        u.display = name ? name : u.name
        modifiedUsers.push(u)
    })

    console.log(uploading);

    const uploadAttachments = async () => {
        setAttachments([])
        var modifiedAttachments: any

        // Get Signed URLs
        const promises = attachments.map((a: IAttachment) => LoopApi(null, 'S3PresignedURL', {
            type: a.file.type,
            fileExtension: a.file.name.substr(a.file.name.lastIndexOf('.') + 1)
        }, undefined))

        let signedUrls = await Promise.all(promises)
        modifiedAttachments = attachments.map((file: IAttachment, index: number) => ({
            ...file,
            signedUrl: signedUrls[index]
        }))

        // Upload the File
        const uploadPromises = modifiedAttachments.map(async (file: any, index: number) => {
            let type = file.file.type
            // setUploading(dummyArr)

            //Axios config for upload progress
            const config = {
                onUploadProgress: function (progressEvent: any) {
                    const progress = progressEvent.loaded / progressEvent.total

                    setUploading((prevState: any) => ({ ...prevState, [index]: { progress, ...file } }))

                },
                headers: { "Content-Type": type }
            }

            try {
                let fileToUpload = file.file

                const { data } = await axios.put(file.signedUrl.url, fileToUpload, config)
                return data
            } catch (err) {
                return null
            }
        })

        let photos: any = [], files: any = []

        await Promise.all(uploadPromises).then(() => {
            modifiedAttachments.map((a: any, idx: number) => {
                if (a.file.type.indexOf('image') === 0) {
                    photos.push(a.signedUrl.imgUrl)
                } else {
                    files.push(a)
                }

                if (modifiedAttachments.length - 1 === idx) {
                    sendAttachments(files, photos)
                }
            })
        })

    }

    const sendAttachments = (files: any, photos: any) => {

        if (!!photos.length) {
            //@ts-ignore
            var doc = window.shareDbConnection.get('chat-contents', ObjectId())
            const timeStamp = new Date().getTime()

            doc.create({
                receiver,
                meetingURL,
                sender: {
                    avatar: myInfo.avatar_url || '',
                    name: myInfo.name,
                    id: myId
                },
                type: 'photos',
                timeStamp,
                photos,
                reactions: []
            }, (err: any) => { if (err) console.error(err) })

        }

        if (!!files.length)
            files.map((f: any) => {
                //@ts-ignore
                var fileDoc = window.shareDbConnection.get('chat-contents', ObjectId())
                const timeStamp = new Date().getTime()

                fileDoc.create({
                    receiver,
                    meetingURL,
                    sender: {
                        avatar: myInfo.avatar_url || '',
                        name: myInfo.name,
                        id: myId
                    },
                    type: 'files',
                    timeStamp,
                    file: {
                        type: f.file.type,
                        name: f.file.name,
                        url: f.signedUrl.imgUrl,
                        size: f.file.size
                    },
                    reactions: []
                }, (err: any) => { if (err) console.error(err) })
            })


    }

    const extractMesssage = () => {

        let mentions: any = []
        let text = message.trim();

        const patmentns = /(\@\[[^\]]+\]\([^\)]+\))/g
        const mentns = text.match(patmentns)
        if (mentns && mentns.length) {
            mentns.map(mentn => {
                const patmentn = /\[([^\]]+)\]\(([^\)]+)\)$/g
                const mentnMatches = [...mentn.matchAll(patmentn)][0]
                if (mentnMatches.length > 0) {
                    const name = mentnMatches[1]
                    const userid = mentnMatches[2]
                    const matched = modifiedUsers.find(u => userid === u.id)
                    if (!!matched) {
                        mentions.push(userid)
                        text = text.replace(mentn, `@${name}`)
                    }
                }
            })
        }

        !!mentions.length && props.sendNotification({
            body: {
                type: 'mention'
            },
            target_user_ids: mentions,
            widget: 'chat'
        })

        sendText(text)
    }

    const handleOnChange = async (e: any) => {
        let files = Array.from(e.target.files)

        if (files.length === 0) {
            return
        }

        const getSrc = (file: any) => {
            return new Promise((resolve) => {
                if (file.type.indexOf("image") !== 0) {
                    resolve('')
                }
                var reader = new FileReader();
                reader.onload = event => {
                    if (event.target) {
                        resolve(event.target.result)
                    } else {
                        resolve('')
                    }
                };
                reader.readAsDataURL(file)
            })
        }

        const promises = files.map(file => getSrc(file))
        const sources = await Promise.all(promises)

        files = files.map((file, index) => {
            return {
                file,
                src: sources[index]
            }
        })

        setAttachments((prevState: any) => [...prevState, ...files]);

    }



    const removeAttachment = (index: number) => {
        let newArr = attachments

        console.log(newArr);
        newArr.splice(index, 1)

        setAttachments([...newArr])
    }


    return (
        <MainCont>
            <Header>
                {roomName}
                <UserIcon>
                    <FiUser />
                    <span style={{ marginLeft: '2px', fontWeight: 'normal' }}>
                        {chatDB?.users?.length}
                    </span>
                </UserIcon>
            </Header>
            <ChatContent>
                <Conversations uploading={uploading} receiver={receiver} meetingURL={meetingURL} sender={myId} />
            </ChatContent>
           
            <Footer >

                {!!attachments?.length &&
                    <Attachments flex={attachments?.length > 2}>
                        <AttachBinder>
                            {attachments.map((f: any, key: number) =>
                                <Attachment key={key} className='container'>
                                    <div className='delete' onClick={() => removeAttachment(key)}>
                                        <AiOutlineCloseCircle size={22} />
                                    </div>
                                    {f.src ?
                                        <img
                                            src={f.src}
                                            alt={f.file.name}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain'
                                            }}
                                        />
                                        :
                                        <>
                                            <FileIconWrapper>

                                                <FIleType>
                                                    {f.file.name.substr(f.file.name.lastIndexOf('.') + 1)}
                                                </FIleType>
                                                <AiOutlineFile size={32} />
                                            </FileIconWrapper>
                                            <FileName>{f.file.name}</FileName>
                                            <FileSize> {formatBytes(f.file.size)}</FileSize>
                                        </>
                                    }

                                </Attachment>)}
                            {/* {Add Button} */}
                            <Attachment className='add container' onClick={() => fileInput.current.click()}>
                                <RiAddLine size={25} />
                            </Attachment>
                        </AttachBinder>
                    </Attachments>
                }
                <input
                    type="file"
                    ref={fileInput}
                    hidden
                    multiple
                    onChange={handleOnChange}
                />
                <InputButtonBinder>
                    <MentionsInput
                        className="chat-widget-mentions-input topbar"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        style={style}
                        placeholder={"Mention people using '@'"}
                        a11ySuggestionsListLabel={"Suggested mentions"}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) extractMesssage()
                        }}
                    >
                        <Mention

                            // markup="@[__display__](name)"
                            trigger="@"
                            data={(modifiedUsers || []).filter((u) => u.id !== myId)}
                            renderSuggestion={(suggestion: any, search, highlightedDisplay) => {

                                return <div className="user">
                                    {suggestion.display == 'All' ?
                                        <div style={{ width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <FaUsers size={22} />
                                        </div>
                                        :
                                        <ChatAvatar id={suggestion.id} small />}
                                    <span className='user-name'>
                                        {suggestion.display}
                                    </span>
                                </div>
                            }
                            }
                            // onAdd={onAdd}
                            displayTransform={(_, display) => `@${display}`}
                            style={{ overflow: 'auto' }}
                        />
                    </MentionsInput>

                    {/* {BUTTONS} */}
                    <ButtonCont onClick={extractMesssage} className='topbar'>
                        <AiOutlineSend style={{ opacity: `${(message !== '' || !!attachments?.length) ? '1' : '.5'}` }} size={20} />
                        {/* <AiOutlineSend size={20} /> */}
                    </ButtonCont>

                    <ButtonCont className='topbar' onClick={() => fileInput.current.click()}>
                        < MdAttachFile size={20} />
                    </ButtonCont>
                </InputButtonBinder>

            </Footer>

        </MainCont>
    )

}

let style = {
    borderRadius: 10,
    maxWidth: 'calc(100% - 43px)',
    width: '100%',
    input: {
        overflow: 'auto',
        borderRadius: 10,
        padding: 8,
        maxHeight: 100,
        border: 'solid 1px lightgray',
        color: 'inherit'
    },
    highlighter: {
        boxSizing: 'border-box',
        overflow: 'hidden',
        maxHeight: 100,
        minHeight: 35,
    },
}

const FileName = styled.span`
    margin-top: auto;
    margin-bottom: 5px;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    
`
const FileSize = styled.span`
    font-size: 10px;
`

const FIleType = styled.span`
    position: absolute;
    font-size: 10px;
    margin-top: 5px;
`

const FileIconWrapper = styled.div`
    justify-content: center;
    align-items: center;

    display: flex;
   
`

const Attachments = styled.div<{ flex: boolean }>`
    overflow: auto;
    width: 100%;
    display: flex;
    flex-direction: ${({ flex }) => flex ? 'row-reverse' : 'row'};
`

const AttachBinder = styled.div`
    display: flex;
    flex-direction: row;
    margin: 10px 10px 0 10px;

    .add{
        justify-content: center;
        align-items: center;
    }
`

const Attachment = styled.div`
    min-height: 70px;
    min-width: 100px;
    max-height: 70px;
    max-width: 70px;
    display: flex;
    margin: 0 10px 2px 10px;
    overflow: hidden;
    flex-direction: column;
    padding: 5px;
    cursor: pointer;
    user-select: none;
    position: relative;

    :hover{
        .delete{
            opacity: 1;
        }
    }
    .delete{
        opacity: 0;
        position: absolute;
        top: 0;
        right: 0;
    }
`

const MainCont = styled.div`
    max-height: 500px;
    min-height: 500px;
    display: flex;
    flex-direction: column;

    .no-note {
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.4;
        height: 500px;
        font-weight: 400;
    }

    @media (max-height: 740px) {
        min-height: 333px;
        max-height: 333px;

        .no-note {
            height: 333px;
        }
    }

    @media (max-width: 480px) {
        min-height: 277px;
        max-height: 277px;

        .no-note {
            height: 280px;
        }
    }
`

const UserIcon = styled.div`
    background-color: lightgray;
    padding: 5px;
    margin-left: auto;
    border-radius: 5px;
    display: flex;
`

const Header = styled.div`
    display: flex;
    align-items: center ;
    height: 50px;
    padding: 10px 10px 10px 15px;
    font-weight: bold;
`

const ChatContent = styled.div`
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column-reverse;
`
const Footer = styled.div`
    margin-top: 2px;
    flex-direction: column;
    display: flex;
`

const InputButtonBinder = styled.div`
    height: fit-content;
    padding: 10px;
    display: flex;
    align-items: center;
    max-height: 120px;

    .chat-widget-mentions-input__suggestions {
        bottom: 32px !important;
        top: unset !important;
        border-radius: 10px;
        min-width: 150px !important;
        box-shadow: ${props => props.theme.shadows.newheavy};
        > ul {
            border: 1px solid lightgray;
            border-radius: 10px;

            > li {
                padding: 2px;
                padding: 6px 10px;
                &:not(:last-child) {
               
                    margin-bottom: 2px;
                }

                &:last-child{
                    border-bottom-right-radius: 10px;
                    border-bottom-left-radius: 10px;
                }

                &:first-child{
                    border-top-right-radius: 10px;
                    border-top-left-radius: 10px;
                }
            }
        }
    }
    
    .chat-widget-mentions-input__suggestions__list {
        color: inherit;
        font-size: 16px;
        padding: 5px 15px;
        max-height: 200px;
        overflow-y: auto;
    }

    .user{
        display: flex;
        align-items: center;
        max-width: 300px;
        min-width: 200px;
    }

    .user-name{
        margin-left: 5px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
    }
`


const ButtonCont = styled.div`
    width: 40px;
    height: 35px;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center ;
    margin-left: 5px;
    border: 1px solid lightgray;
    border-radius: 10px;
    cursor: pointer;
`

export default ChatV2